module.exports = __webpack_public_path__ + "img/11.48d5bc3f.svg";